function normalizeUrl(value) {
  const url = String(value || "").trim()
  return url || null
}

function firstPresent(values) {
  return values.find((value) => value) || null
}

function buildImageState({ url, files = [], previews = [] }) {
  return {
    url: normalizeUrl(url),
    file: firstPresent(files),
    previewDataUrl: firstPresent(previews),
  }
}

export function buildApplePreviewState(input) {
  return {
    name: input.name || "",
    show_name_on_apple_card: input.show_name_on_apple_card !== false,
    background_colour: input.background_colour || "#ffffff",
    foreground_colour: input.foreground_colour || "#000000",
    label_colour: input.label_colour || "#000000",
    images: {
      logo: buildImageState({
        url: input.ios_logo,
        files: [input.card_logo_image_wide_source, input.card_logo_image_square_source, input.ios_logo_file],
        previews: [
          input.card_logo_image_wide_preview,
          input.card_logo_image_wide_preview_from_dom,
          input.card_logo_image_square_preview,
          input.card_logo_image_square_preview_from_dom,
        ],
      }),
      strip: buildImageState({
        url: input.ios_strip,
        files: [input.card_strip_image_source, input.ios_strip_file],
        previews: [input.card_strip_image_preview, input.card_strip_image_preview_from_dom],
      }),
    },
  }
}

export function buildGooglePreviewState(input) {
  return {
    name: input.name || "",
    background_colour: input.background_colour || "#ffffff",
    foreground_colour: input.foreground_colour || "#000000",
    label_colour: input.label_colour || "#000000",
    images: {
      logo: buildImageState({
        url: input.logo_android,
        files: [input.card_logo_image_square_source, input.logo_android_file],
        previews: [input.card_logo_image_square_preview, input.card_logo_image_square_preview_from_dom],
      }),
      hero: buildImageState({
        url: input.logo_large,
        files: [input.card_hero_image_source, input.logo_large_file],
        previews: [input.card_hero_image_preview, input.card_hero_image_preview_from_dom],
      }),
    },
  }
}
